export default {"src":"/_next/static/media/thumbs_up.48ff69c9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};